import Marquee from "react-fast-marquee";

const words = ["Prenatal Care", "Gynaecology", "Fertility & PCOS", "High-Risk Pregnancy", "Menopause", "Well-Woman", "Adolescent Health"];

export default function EditorialMarquee() {
  return (
    <div className="bg-accent/90 py-6 border-y border-accent">
      <Marquee speed={38} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-accent-foreground text-3xl sm:text-4xl px-8">{w}</span>
            <span className="text-accent-foreground/50 text-2xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
